<template>
  <div class="my_own">
    <div class="own_glass">
      <p class="user">账号：{{ userName }}</p>
      <p class="dept_info">
        {{ deptName }}
      </p>
    </div>
    <div class="own_action">
      <div class="own_box">
        <div class="fir" @click="goDeptCheck">
          <img src="../../assets/img/tydept.png" alt="" />
          <span class="own_word"> 当前单位 </span>
          <van-icon name="arrow" />
        </div>
        <div v-if="flagObj&&flagObj.paidFlag" class="sec" @click="getOrders">
          <img src="../../assets/img/tylook.png" alt="" />
          <span class="own_word"> 查看已缴费数据 </span>
          <van-icon name="arrow" />
        </div>
        <div class="sec" @click="remakePwd">
          <img src="../../assets/img/remarkPng.png" alt="" />
          <span class="own_word"> 修改密码 </span>
          <van-icon name="arrow" />
        </div>
        <div class="thd" @click="logout">
          <img src="../../assets/img/tyexit.png" alt="" />
          <span class="own_word"> 退出登录 </span>
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="deptList"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { setToken, getCookie, getUser } from "@/utils/common";
import { Notify, Dialog } from "vant";
export default {
  data() {
    return {
      userName: "",
      deptName: "",
      deptList: [],
      showPicker: false,
      deptId: "",
      sex: getUser().sex,
      flagObj:null,
    };
  },
  created() {
    this.getAuth();
    this.getDeptMsg();
  },
  mounted(){
    if(localStorage.getItem('flagObj')){
        this.flagObj=JSON.parse(localStorage.getItem('flagObj'));
    }
    if(sessionStorage.getItem('isTyType')=='1'){
      sessionStorage.removeItem('isTyType');
      this.$emit('reloadData');
    }
  },
  methods: {
    remakePwd() {
      this.$router.push({
        path: "/remakePwd",
        query: {
          vde: this.$route.query.vde,
        },
      });
    },
    goDeptCheck() {
      // 逻辑变更为点击当前单位后，去其他页面进行单位的切换
      this.$router.push({
        path: "/selectDept",
        query: {
          userName: this.userName,
        },
      });
    },
    getAuth() {
      this.request({
        url: "/user/getAuth",
        method: "get",
      }).then((res) => {
        if (res.data.code == 1000) {
          sessionStorage.setItem("user", JSON.stringify(res.data.result.user));
          this.userName = res.data.result.user.userName;
          this.deptName = `${res.data.result.user.deptName}`;
        }
      });
    },
    // 单位信息
    getDeptMsg() {
      this.request({
        url: "/userAuth/dept/getDeptListByUserName",
        method: "get",
      }).then((res) => {
        if (res.data.code == 1000) {
          this.deptList = res.data.result.list;
          this.deptList.forEach((item) => {
            item.text = `[${item.deptId}]${item.deptName}`;
          });
        }
      });
    },
    // 切换单位
    onConfirm(val) {
      this.deptId = val.deptId;
      this.request({
        url: "/user/getAuthSwitch",
        method: "post",
        params: { deptId: this.deptId },
      }).then((res) => {
        if (res.data.code == 1000) {
          Notify({ type: "success", message: "切换成功" });
          this.showPicker = false;
          this.getAuth();
        } else {
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            textSize: 16,
            message: res.data.message,
          }).then((res) => {});
          // Dialog.confirm({
          //     title: '提示',
          //     message: res.data.message,
          // }).then(()=>{

          // })
        }
      });
    },
    logout() {
      this.$CDialog({
        confirmBtnText: "确认", //按钮文字
        title: "提示", //title提示文字
        message: "确定要退出登录吗？", //弹窗内容
        status: "2", //显示哪种图   1 为绿色   2为蓝色
        textSize: "16", // 字体大小，默认12
        cancelBtnText: "取消",
      })
        .then((res) => {
          let data = {
            token: getCookie("token"),
          };
          this.request({
            url: "/sso/logout",
            method: "post",
            data: data,
          }).then((res) => {});
          setTimeout(() => {
            Notify({ type: "success", message: "退出成功" });
            setToken("");
            this.$router.push({
              path:
                "/login?vde=" +
                localStorage.getItem("vde") +
                "&fromtype=" +
                localStorage.getItem("loginFromType"),
            });
          }, 1000);
          //点击确定之后的处理
        })
        .catch((rs) => {});
      // Dialog.confirm({
      //     title: '提示',
      //     message: '确定要退出登录吗？',
      // })
      // .then(() => {
      //     let data={
      //         token:getCookie('token')
      //     }
      //     this.request({
      //         url:'/sso/logout',
      //         method:'post',
      //         data:data
      //     }).then((res)=>{

      //     })
      //     setTimeout(()=>{
      //         Notify({ type: 'success', message: '退出成功' });
      //         setToken('');
      //         this.$router.push({ path: "/login?vde="+localStorage.getItem('vde')+'&fromtype='+localStorage.getItem('loginFromType')})
      //     },1000)
      // })
      // .catch(() => {
      // });
    },
    // 查看已缴费数据
    getOrders() {
      this.$router.push({
        path: "/bussiess/paidList",
        query: {
          vde: this.$route.query.vde,
          userCode: getUser().userName,
        },
      });
      sessionStorage.setItem("bussiessActive", 2);
    },
  },
};
</script>

<style lang='scss' scoped>
.my_own {
  height: 100vh;
  background: url("../../assets/img/backLogin.png") no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  ::v-deep .van-picker-column__item {

    font-size: 18px;
    color: rgba(70, 74, 76, 0.7);
    letter-spacing: 0;
    font-weight: 400;
  }
  ::v-deep .van-picker-column__item--selected {

    font-size: 20px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 500;
  }
  ::v-deep .van-picker__cancel {

    font-size: 16px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 500;
  }
  ::v-deep .van-picker__confirm {

    font-size: 16px;
    color: #208fff;
    letter-spacing: 0;
    font-weight: 500;
  }
  .own_glass {
    width: 345px;
    height: 149px;
    margin: 0 auto;
    background: url("../../assets/img/myInfo.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    top: 48px;
    padding-left: 114px;
    box-sizing: border-box;
    padding-top: 42px;
    .user {
      width: 210px;
      word-break: break-all;

      font-size: 16px;
      color: #ffffff;
    }
    .dept_info {
      margin-top: 10px;
      width: 210px;
      word-break: break-all;
      font-weight: 400;

      font-size: 14px;
      color: #ffffff;
      line-height: 22px;
    }
  }
  .own_action {
    height: calc(100vh - 202px);
    background: url("../../assets/img/myAvatar.png") no-repeat;
    background-size: 100% 100%;
    padding-top: 81px;
    box-sizing: border-box;
    .own_box {
      width: 345px;
      margin: 0 auto;
      background: #ffffff;
      border-radius: 10px;
      padding: 10px 20px;
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.15);
      box-sizing: border-box;
      img {
        width: 36px;
        height: 36px;
      }
      .own_word {
        margin-left: 12px;

        font-size: 16px;
        color: #464a4c;
        letter-spacing: 0;
        line-height: 36px;
        font-weight: 400;
      }
      > div {
        position: relative;
      }
      ::v-deep .van-icon {
        color: rgba(35, 25, 22, 0.3);
        font-size: 14px;
        position: absolute;
        right: 0px;
        top: 29px;
      }
      .fir {
        border-bottom: 1px solid #eee;
        padding: 18px 0px;
        height: 70px;
        box-sizing: border-box;
      }
      .sec {
        border-bottom: 1px solid #eee;
        padding: 18px 0px;
        height: 70px;
        box-sizing: border-box;
      }
      .thd {
        padding: 18px 0px;
        height: 70px;
        box-sizing: border-box;
      }
    }
  }
}
</style>
